export const I18nPrefix = 'components.invite_your_friends';

export default { I18nPrefix };
